import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { Button } from '@gemini/ui';
import { ExternalLinkIcon } from '@gemini/icons';
import Container from '@/components/structure/Container';
import { useTranslation } from '@/hooks/useTranslations';
import List from '@/components/structure/List';
import BlockTitle from '@/components/structure/BlockTitle';
import { getImageSrc } from '@/utils/getImageSrc';
export const CallToAction = ({ name }) => {
    const { t } = useTranslation();
    const list = [];
    for (let i = 1; i <= 3; i++) {
        const text = `fsrbo.generic.calltoaction.list.item${i}`;
        list.push({
            id: text,
            text,
        });
    }
    return (_jsx(Container, { noPaddingMobile: true, children: _jsxs(Box, { width: "100%", borderRadius: {
                'breakpoint.base': 'radius.none',
                'breakpoint.md': 'radius.16',
            }, backgroundColor: "color.surface.brand.primary.default", paddingHorizontal: {
                'breakpoint.base': 'spacing.16',
                'breakpoint.lg': 'spacing.80',
            }, paddingVertical: {
                'breakpoint.base': 'spacing.32',
                'breakpoint.md': 'spacing.64',
                'breakpoint.lg': 'spacing.80',
            }, display: "flex", alignItems: "center", flexDirection: { 'breakpoint.base': 'column', 'breakpoint.lg': 'row' }, children: [_jsx(Box, { flex: {
                        'breakpoint.base': '1 1 auto',
                        'breakpoint.lg': '0 0 50%',
                        'breakpoint.xl': '0 0 576px',
                    }, children: _jsx(Box, { borderRadius: "radius.16", backgroundColor: {
                            'breakpoint.base': 'color.surface.transparent.default',
                            'breakpoint.lg': 'color.surface.active.hover',
                        }, display: "flex", alignItems: "center", justifyContent: "center", paddingVertical: {
                            'breakpoint.base': 'spacing.none',
                            'breakpoint.lg': 'spacing.40',
                        }, marginBottom: {
                            'breakpoint.base': 'spacing.16',
                            'breakpoint.lg': 'spacing.none',
                        }, children: _jsx(Box, { as: "img", src: getImageSrc('building-value.svg'), alt: "building value" }) }) }), _jsxs(Box, { borderRadius: "radius.16", backgroundColor: "color.background.constant.white", padding: "spacing.32", marginLeft: {
                        'breakpoint.base': 'spacing.none',
                        'breakpoint.lg': '-spacing.32',
                    }, children: [_jsx(Box, { marginBottom: "spacing.8", children: _jsx(BlockTitle, { as: "h2", children: t('fsrbo.generic.calltoaction.title') }) }), _jsx(Box, { typography: "typography.body.16.regular", marginBottom: "spacing.24", children: t('fsrbo.generic.calltoaction.subtitle') }), _jsx(List, { items: list, spacing: "spacing.8" }), _jsx(Button, { variant: "primary", icon: ExternalLinkIcon, iconPosition: "end", href: "https://www.nutzungsdauer.com/abschreibung-immobilie/?promo=IWT24&utm_source=immowelt&utm_medium=nutzungsdauerlandingpage", marginTop: "spacing.24", children: t(`fsrbo.${name}.calltoaction.button`) })] })] }) }));
};
